function stickyBuyButton(){

  window.addEventListener('scroll', function () {

    var stickyButton = document.querySelector('.sticky-buy-button');
    
    if ( stickyButton != null ) {      
     
      const lastVideo = document.querySelectorAll('.video-hero--1');
      const lastElement = lastVideo[lastVideo.length - 1];

      //var lastItem = document.querySelector('.js-pdp-last-elem');

      //var heightToStick = lastItem.offsetHeight - 40;
      var moodOffset = lastElement.offsetTop;
      // var moodHeight = lastElement.offsetHeight;
      var winScroll = window.scrollY;
      var positionTop = moodOffset;

      console.log(window.innerHeight, winScroll);

      if (winScroll > positionTop) {

        stickyButton.style.top = `${positionTop}px`;
        document.body.classList.add('pdp-sticky-button-active');

      } else {

        stickyButton.style.top = 'unset';
        document.body.classList.remove('pdp-sticky-button-active');

      }
    }
    
 
  });
}
export default stickyBuyButton